/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { MythPass, MythPassInterface } from "../MythPass";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "airdropList",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "baseURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "buyNum",
        type: "uint16",
      },
    ],
    name: "buyGoldenPass",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "newUri",
        type: "string",
      },
    ],
    name: "changeBaseURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "root",
        type: "bytes32",
      },
      {
        internalType: "bytes32[]",
        name: "proof",
        type: "bytes32[]",
      },
    ],
    name: "checkWhitelist",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "claimClassicPass",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "claimEndTime",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "airdropNum",
        type: "uint8",
      },
      {
        internalType: "bytes32[]",
        name: "proof",
        type: "bytes32[]",
      },
    ],
    name: "claimGoldenPass",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "classicPassNum",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "classicTokenId",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "freeMintList",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8[]",
        name: "airdropNums",
        type: "uint8[]",
      },
      {
        internalType: "bytes32[][]",
        name: "proofs",
        type: "bytes32[][]",
      },
    ],
    name: "getAvailableForMinting",
    outputs: [
      {
        internalType: "uint8[]",
        name: "",
        type: "uint8[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "goldenPassNum",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "goldenTokenId",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "name",
        type: "string",
      },
      {
        internalType: "string",
        name: "symbol",
        type: "string",
      },
      {
        internalType: "string",
        name: "baseURI_",
        type: "string",
      },
      {
        internalType: "address payable",
        name: "payee_",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "claimEndTime_",
        type: "uint256",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    name: "merkelRoots",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint16",
        name: "num",
        type: "uint16",
      },
      {
        internalType: "bool",
        name: "isGolden",
        type: "bool",
      },
    ],
    name: "mintBatch",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "isPause",
        type: "bool",
      },
    ],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "payee",
    outputs: [
      {
        internalType: "address payable",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "endTime",
        type: "uint256",
      },
    ],
    name: "updateFreeEndTime",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "updateFreeMintActive",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "airdropNum",
        type: "uint8",
      },
      {
        internalType: "bytes32",
        name: "root",
        type: "bytes32",
      },
    ],
    name: "updateFreeMintRoot",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address payable",
        name: "payee_",
        type: "address",
      },
    ],
    name: "updatePayee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type MythPassConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: MythPassConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class MythPass__factory extends ContractFactory {
  constructor(...args: MythPassConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<MythPass> {
    return super.deploy(overrides || {}) as Promise<MythPass>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): MythPass {
    return super.attach(address) as MythPass;
  }
  connect(signer: Signer): MythPass__factory {
    return super.connect(signer) as MythPass__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): MythPassInterface {
    return new utils.Interface(_abi) as MythPassInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): MythPass {
    return new Contract(address, _abi, signerOrProvider) as MythPass;
  }
}
